<template>
  <v-app-bar
    app
    color="transparent"
    dense
    elevate-on-scroll
    fixed
    flat
    src="media/bg/bg-10.webp"
  >
    <walletButton style="flex-basis: 100%" />

    <template v-slot:extension>
      <div>
        <KTDropdownLanguage
          class="ss"
          style="
            background-color: rgba(255, 255, 255, 0.2);
            border-color: rgba(255, 255, 255, 0.2);
            color: white;
            border: white solid 1px;
            margin-right: 8px;
            margin-left: 8px;
          "
          v-if="shouldShowLanguageDropdown"
        />
        <v-btn
          class="white--text rounded-lg"
          color="rgba(255, 255, 255, .2)"
          depressed
          href="/#/dashboard"
          large
        >
          {{ i18n.t("dashboard_origin") }}
        </v-btn>

        <v-btn
          :href="$coreApi + '/#/contact/list'"
          class="ms-2 white--text rounded-lg"
          color="rgba(255, 255, 255, .2)"
          depressed
          large
          target="_blank"
        >
          {{ i18n.t("router.contactList") }}
        </v-btn>
      </div>
    </template>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import KTLayoutHeaderTopbar from "../../assets/js/layout/header-topbar.js";
import walletButton from "../../pages/transactions/WalletOpenButton";
import { LOGOUT } from "@/core/services/store/auth.module";
import i18n from "../../plugins/EasyModal/i18n";
import KTDropdownLanguage from "../../layout/extras/dropdown/DropdownLanguage.vue";

export default {
  name: "KTHeaderMobile",

  components: {
    walletButton,
    KTDropdownLanguage,
  },

  data: () => ({
    unread: 0,
    i18n,
  }),

  mounted() {
    // Init Header Topbar For Mobile Mode
    KTLayoutHeaderTopbar.init(this.$refs["kt_header_mobile_topbar_toggle"]);
  },

  methods: {
    onLogout() {
      this.$store.dispatch(LOGOUT).then(() => window.location.reload());
    },
  },

  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),
        shouldShowLanguageDropdown() {
      const hostname = window.location.hostname;
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return true;
      }
      const allowedDomainPattern = /^(core-qr|core|core-)\.terminalads\.(com|ir)$/i;
      return allowedDomainPattern.test(hostname);
    },


    /**
     * Get header logo
     * @returns {string}
     */
    headerLogo() {
      return process.env.BASE_URL + this.layoutConfig("self.logo.sticky");
    },

    /**
     * Get classes for mobile header
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header_mobile");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
  },
};
</script>

<style scoped>
.mobileCutomPaddingNotif .b-dropdown-text {
  padding: 0 !important;
}

.v-app-bar.v-app-bar--is-scrolled :deep(.v-toolbar__image) {
  opacity: 1;
}

.v-app-bar :deep(.v-toolbar__image) {
  transition: opacity 0.15s ease-in;
  opacity: 0;
}

.app-bar-img >>> .v-responsive__content {
  display: flex;
  align-items: center;
}
:deep(.ss .v-btn) {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border: white solid 1px !important;
  margin-right: 8px !important;
  margin-left: 8px !important;
}
</style>
